<template>
  <div class="is-widescreen">
    <router-view></router-view>
  </div>
</template>

<script>
export default {};
</script>

<style>
@import './assets/styles/main.css';

div {
  border: none;
}
</style>
